(function () {
  const header = document.getElementById("site-header");
  if (!header) return;

  const isHome = header.dataset.transparent === "true";

  if (isHome) {
    // Homepage: transparent at top, white on scroll
    const updateScrollState = () => {
      if (window.scrollY > 60) {
        header.classList.add("is-scrolled");
      } else {
        header.classList.remove("is-scrolled");
      }
    };
    window.addEventListener("scroll", updateScrollState, { passive: true });
    updateScrollState();
  } else {
    // Non-homepage: always solid white background
    header.classList.add("is-solid");
  }

  // Desktop dropdown behavior
  const navItems = header.querySelectorAll("[data-nav-item]");
  navItems.forEach((item) => {
    const btn = item.querySelector(".nav-link--btn");
    if (!btn) return;
    item.addEventListener("mouseenter", () =>
      btn.setAttribute("aria-expanded", "true"),
    );
    item.addEventListener("mouseleave", () =>
      btn.setAttribute("aria-expanded", "false"),
    );
  });
})();
